import _extends from "@babel/runtime/helpers/extends";
import { SVGIcon } from '@alilc/lowcode-utils';
export function IconExit(props) {
  return /*#__PURE__*/React.createElement(SVGIcon, _extends({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M723.872 478.4l-81.12-81.152L688 352l135.776 135.776L846.4 510.4 688 668.8l-45.248-45.28 81.12-81.12H384v-64h339.872zM576 896H256.192A64.16 64.16 0 0 1 192 831.84V192.16c0-35.424 28.704-64.16 64.192-64.16H576v64H288.224A31.968 31.968 0 0 0 256 223.744v576.512C256 817.44 270.4 832 288.224 832H576v64z"
  }));
}
IconExit.displayName = 'Exit';